import { useRouter } from 'vue-router';
import { useAlertsStore } from '@/store/AlertsStore';
import gettext from '@/i18n/gettext';

const { $gettext } = gettext;

export const useCopyBomLink = () => {
  const router = useRouter();
  const alerts = useAlertsStore();

  const copyBomLink = async (projectUuid: string, bomUuid: string) => {
    const resolved = router.resolve({
      name: 'catalogue',
      query: { projectId: projectUuid, bomId: bomUuid },
    });
    const url = window.location.origin + resolved.href;
    await navigator.clipboard.writeText(url);
    alerts.success($gettext('Link copied to clipboard'));
  };

  return { copyBomLink };
};
